import React from "react";
import { Inbox } from "lucide-react";

export default function EmptyState({ title = "Nothing here yet", description, icon: Icon = Inbox, action, testid }) {
  return (
    <div
      data-testid={testid || "empty-state"}
      className="flex flex-col items-center justify-center text-center py-16 px-6"
    >
      <div className="w-12 h-12 rounded-xl bg-[#F0F6F1] border border-[#0E5B52]/10 flex items-center justify-center">
        <Icon className="w-5 h-5 text-[#0E5B52]" />
      </div>
      <h3 className="mt-3 font-display text-[15px] font-semibold text-[#0F2A26]">{title}</h3>
      {description && <p className="text-[13px] text-[#6B7280] mt-1 max-w-sm">{description}</p>}
      {action && <div className="mt-4">{action}</div>}
    </div>
  );
}
